import { render, staticRenderFns } from "./MyStudy.vue?vue&type=template&id=4d52889e&scoped=true"
import script from "./MyStudy.vue?vue&type=script&lang=js"
export * from "./MyStudy.vue?vue&type=script&lang=js"
import style0 from "./MyStudy.vue?vue&type=style&index=0&id=4d52889e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52889e",
  null
  
)

export default component.exports